export default "__VITE_ASSET__DdTFsOwy__"